import $ from 'jquery';

import colors from '../../../../../../../lib/colors'

export default function(o,data){

  if(data.auth && !_.includes(data.auth, o.store('role'))){
    return null
  }

  var dataDiv = data.type.getTableDiv(data.value)

  var div =
    $('<div>')
    .css({
      overflow: 'hidden',
      height: '34px',
      display: 'table-cell',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      minWidth: '100px',
      maxWidth: '500px',
      verticalAlign: 'top',
      color: 'white',
      borderRight: '1px solid ' + colors.grey.s_800,
      borderBottom: '1px solid ' + colors.grey.s_800,
    })
    .append(
      dataDiv
    )

  if(data.click){
    div.click(data.click)
  }

  if(data.width){
    div.css({
      minWidth: '',
      maxWidth: '',
    })
    dataDiv.css({
      width: data.width+'px',
    })
  }

  if(data.multiline){
    div.css({
      whiteSpace: '',
      textOverflow: '',
    })
  }

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/rows/row/column/column.js